import Network from 'infrastructure/js/modules/network';

export function fetchKitTypes(query = {}) {
  return Network.post('kittype/items', query);
}
export function fetchArchivedKitTypes(query = {}) {
  return Network.post('kittype/items/archived', query);
}


export function fetchAllKitTypes() {
  return Network.get('kittypes');
}

export function fetchAllKitTypesFirstRevisionOnly() {
  let requestModel = {
    firstRevision: true,
  };
  return Network.get('kittypes', requestModel);
}


export function createKitType(data) {
  return Network.post('kittypes', data);
}

export function setKitTypeOperations(data) {
  return Network.post('kittypes/operations', data);
}

export function editKitType(data) {
  let id = data.id;
  delete data.id;
  return Network.put(`kittypes/${id}`, data);
}

export function cloneKitType({ id, ...rest }) {
  return Network.post(`kittypes/${id}/clone`, rest);
}

export function removeKitTypes(ids) {
  return Network.delete('kittypes/', { kitTypeIds: ids.ids });
}

export function importKitTypesJson(file) {
  return Network.postFile('batch/import/kittypes/jsonplain/upload', file);
}

export function getKitType(id) {
  return Network.get(`kittypes/${id}`);
}

export function getWorkOrdersByKitTypes(data) {
  return Network.post('kittypes/workorders', data);
}

export function updateWorkOrdersKitTypeVersion(data) {
  return Network.post('workorders/change-kittype', data);
}

export function updateWorkOrdersMultiKitTypesVersions(data) {
  return Network.post('workorders/change-multi-kittypes', data);
}



